import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchIntegrationStates = createAction(
  constants.FETCH_INTEGRATION_STATES
)
export const fetchIntegrationStatesSuccess = createAction(
  constants.FETCH_INTEGRATION_STATES_SUCCESS
)
export const fetchIntegrationStatesFailed = createAction(
  constants.FETCH_INTEGRATION_STATES_FAILED
)
export const fetchIntegrationStatesPending = createAction(
  constants.FETCH_INTEGRATION_STATES_PENDING
)

export const updateIntegrationState = createAction(
  constants.UPDATE_INTEGRATION_STATE
)
export const updateIntegrationStateSuccess = createAction(
  constants.UPDATE_INTEGRATION_STATE_SUCCESS
)
export const updateIntegrationStateFailed = createAction(
  constants.UPDATE_INTEGRATION_STATE_FAILED
)
export const updateIntegrationStatePending = createAction(
  constants.UPDATE_INTEGRATION_STATE_PENDING
)

export const fetchFacebookSettings = createAction(
  constants.FETCH_FACEBOOK_SETTINGS
)
export const fetchFacebookSettingsPending = createAction(
  constants.FETCH_FACEBOOK_SETTINGS_PENDING
)
export const fetchFacebookSettingsFailed = createAction(
  constants.FETCH_FACEBOOK_SETTINGS_FAILED
)
export const fetchFacebookSettingsCancelled = createAction(
  constants.FETCH_FACEBOOK_SETTINGS_CANCELLED
)
export const fetchFacebookSettingsSuccess = createAction(
  constants.FETCH_FACEBOOK_SETTINGS_SUCCESS
)

export const fetchOutreachStatus = createAction(constants.FETCH_OUTREACH_STATUS)
export const fetchOutreachStatusPending = createAction(
  constants.FETCH_OUTREACH_STATUS_PENDING
)
export const fetchOutreachStatusFailed = createAction(
  constants.FETCH_OUTREACH_STATUS_FAILED
)
export const fetchOutreachStatusSuccess = createAction(
  constants.FETCH_OUTREACH_STATUS_SUCCESS
)

export const createAccessToken = createAction(constants.CREATE_ACCESS_TOKEN)
export const createAccessTokenPending = createAction(
  constants.CREATE_ACCESS_TOKEN_PENDING
)
export const createAccessTokenFailed = createAction(
  constants.CREATE_ACCESS_TOKEN_FAILED
)
export const createAccessTokenSuccess = createAction(
  constants.CREATE_ACCESS_TOKEN_SUCCESS
)

export const createSlackbotToken = createAction(constants.CREATE_SLACKBOT_TOKEN)

export const setWordpressV2Integration = createAction(
  constants.SET_WORDPRESS_V2_INTEGRATION
)
export const setWordpressV2IntegrationPending = createAction(
  constants.SET_WORDPRESS_V2_INTEGRATION_PENDING
)
export const setWordpressV2IntegrationSuccess = createAction(
  constants.SET_WORDPRESS_V2_INTEGRATION_SUCCESS
)
export const setWordpressV2IntegrationFailed = createAction(
  constants.SET_WORDPRESS_V2_INTEGRATION_FAILED
)

export const setWordpressDomain = createAction(constants.SET_WORDPRESS_DOMAIN)
export const setWordpressDomainPending = createAction(
  constants.SET_WORDPRESS_DOMAIN_PENDING
)
export const setWordpressDomainSuccess = createAction(
  constants.SET_WORDPRESS_DOMAIN_SUCCESS
)
export const setWordpressDomainFailed = createAction(
  constants.SET_WORDPRESS_DOMAIN_FAILED
)

export const fetchWordpressDomain = createAction(
  constants.FETCH_WORDPRESS_DOMAIN
)
export const fetchWordpressDomainPending = createAction(
  constants.FETCH_WORDPRESS_DOMAIN_PENDING
)
export const fetchWordpressDomainSuccess = createAction(
  constants.FETCH_WORDPRESS_DOMAIN_SUCCESS
)
export const fetchWordpressDomainFailed = createAction(
  constants.FETCH_WORDPRESS_DOMAIN_FAILED
)

export const getLeanDataAuthStatus = createAction(
  constants.GET_LEANDATA_AUTH_STATUS
)
export const getLeanDataAuthStatusPending = createAction(
  constants.GET_LEANDATA_AUTH_STATUS_PENDING
)
export const getLeanDataAuthStatusFailed = createAction(
  constants.GET_LEANDATA_AUTH_STATUS_FAILED
)
export const getLeanDataAuthStatusCancelled = createAction(
  constants.GET_LEANDATA_AUTH_STATUS_CANCELLED
)
export const getLeanDataAuthStatusSuccess = createAction(
  constants.GET_LEANDATA_AUTH_STATUS_SUCCESS
)

export const createSandBoxAccessToken = createAction(
  constants.CREATE_SANDBOX_ACCESS_TOKEN
)

export const fetchStripeKeys = createAction(constants.FETCH_STRIPE_KEYS)
export const fetchStripeKeysPending = createAction(
  constants.FETCH_STRIPE_KEYS_PENDING
)
export const fetchStripeKeysFailed = createAction(
  constants.FETCH_STRIPE_KEYS_FAILED
)
export const fetchStripeKeysCancelled = createAction(
  constants.FETCH_STRIPE_KEYS_CANCELLED
)
export const fetchStripeKeysSuccess = createAction(
  constants.FETCH_STRIPE_KEYS_SUCCESS
)
